import { createFileRoute } from "@tanstack/react-router"

import { AccessDenied } from "#pages/login/access-denied.tsx"

export const Route = createFileRoute("/_auth/access-denied")({
  component: AccessDenied,
})
